<template>
    <div class="main-text mt-3">
        Последняя сработка:
        <span class="main-text__medium" v-if="time"> {{ getTime(time) }} </span>
        <span class="main-text__medium" v-else> сейчас </span>
    </div>
</template>

<script>
import { updateTime } from '@/utils/index';

export default {
    name: "DeviceSensorTime",
    props: {
        time: {
            type: String,
            default: null,
        }
    },
    methods: {
        getTime(time) {
            return updateTime(time);
        }
    },
}
</script>